import React from 'react'
import type { MouseEventHandler, ReactNode } from 'react'

export function crunchSrcSet(srcset: string[]) {
  return srcset.map(([url, size]) => `${url} ${size}`).join(', ')
}

export function makeArrow({
  alt,
  direction,
  icon,
}: {
  alt?: string
  direction: string
  icon: string
}) {
  const result = ({
    className,
    onClick,
  }: {
    className: string
    onClick: MouseEventHandler<HTMLButtonElement>
  }) => {
    const disabling = className.includes('slick-disabled')
      ? ' c-pagination__item--disabled'
      : ''

    return (
      <li
        className={`c-pagination__item c-pagination__item--${direction}${disabling}`}
      >
        <button
          className={`c-pagination__link c-pagination__link--${direction}`}
          onClick={onClick}
        >
          <img
            src={icon}
            className='c-pagination__icon'
            alt={alt}
            width={12}
            height={12}
          />
        </button>
      </li>
    )
  }

  return result as React.FC
}

export const MAX_REGULAR_THUMBS = 5
